import { Button } from "@heroui/button";

export default function PaymentButton({
  pay,
  isLoading,
  isBookingValid,
  buttonLabel,
}: {
  pay: () => Promise<void>;
  isLoading: boolean;
  isBookingValid: () => boolean;
  buttonLabel: () => string;
}) {
  return (
    <Button
      color="primary"
      size="lg"
      className="w-full"
      onPress={pay}
      isLoading={isLoading}
      isDisabled={!isBookingValid()}
    >
      {buttonLabel()}
    </Button>
  );
}
